import req from './http.js'

const apiGetGuides = async () => {
    const api = '/admin/sys/systemConfig'
    const res = await req('get', api)
    if (res.status !== 200) throw new Error('getGuideList error')
    const guide_config = res.data.data?.find(item => item.id === 'guide')
    if (!guide_config) return null
    return { id: guide_config.id, level: guide_config.level, setting: guide_config.setting }
}

const apiUpdateGuide = async (payload) => {
    const params = 'id=guide'
    const api = `/admin/sys/systemConfig?${params}`
    const res = await req('post', api, payload)
    if (res.status === 200) {
        return res
    }
    throw new Error('updateGuide error')
}

export {
    apiGetGuides,
    apiUpdateGuide,
}